import axios from "axios";

export const getMovimentiApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/`, {
        params: params
    });
}

export const getCsvMovimentiApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/csv/`, {
        params: params
    });
}

export const getMovimentoByIdApi = (idMovimento, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/${idMovimento}`, {
        params: params
    });
}

export const aggiornaMovimentoApi = (idMovimento, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/${idMovimento}`, payload, {
        params: params
    });
}

export const aggiungiMovimentoApi = (payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/`, payload, {
        params: params
    });
}

export const deleteMovimentoApi = (idMovimento, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/${idMovimento}`, {
        params: params
    });
}

export const getContiApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/conto/`, {
        params: params
    });
}

export const getContoByIdApi = (idConto, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/conto/${idConto}`, {
        params: params
    });
}

export const aggiornaContoApi = (idConto, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/conto/${idConto}`, payload, {
        params: params
    });
}

export const aggiungiContoApi = (payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/conto/`, payload, {
        params: params
    });
}

export const deleteContoApi = (idConto, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/conto/${idConto}`, {
        params: params
    });
}

export const getCausaliMovimentoApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/causale-movimento/`, {
        params: params
    });
}

export const aggiornaCausaleMovimentoApi = (idCausale, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/causale-movimento/${idCausale}`, payload, {
        params: params
    });
}

export const aggiungiCausaleMovimentoApi = (payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/causale-movimento/`, payload, {
        params: params
    });
}

export const deleteCausaleMovimentoApi = (idCausale, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/causale-movimento/${idCausale}`, {
        params: params
    });
}

export const getCategorieCausaliMovimentoApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/categoria-causale/`, {
        params: params
    });
}

export const getCategoriaCausaleMovimentoByIdApi = (idCategoria, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/categoria-causale/${idCategoria}`, {
        params: params
    });
}

export const deleteCategoriaCausaleMovimentoApi = (idCategoria, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/categoria-causale/${idCategoria}`, {
        params: params
    });
}

export const aggiornaCategoriaCausaleMovimentoApi = (idCategoria, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/categoria-causale/${idCategoria}`, payload, {
        params: params
    });
}

export const aggiungiCategoriaCausaleMovimentoApi = (payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/categoria-causale/`, payload, {
        params: params
    });
}

export const getTipiMovimentoApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/tipo-movimento/`, {
        params: params
    });
}

export const getTipoMovimentoByIdApi = (idTipo, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/tipo-movimento/${idTipo}`, {
        params: params
    });
}

export const deleteTipoMovimentoApi = (idTipo, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/tipo-movimento/${idTipo}`, {
        params: params
    });
}

export const aggiornaTipoMovimentoApi = (idTipo, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/tipo-movimento/${idTipo}`, payload, {
        params: params
    });
}

export const aggiungiTipoMovimentoApi = (payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/movimento/tipo-movimento/`, payload, {
        params: params
    });
}